import { featureFlags } from "@settings";
import { Amplify } from "aws-amplify";
import { awsconfig } from "aws-exports";

export const amplifyConfigure = () => {
  const isLoginMfa = featureFlags.enableLoginMfaCef;
  if (isLoginMfa) {
    Amplify.configure(awsconfig);
  }
};
